import React, { useEffect, useState } from "react";
import {
  Box, Typography, TextField, Button, Grid,
  FormControl, RadioGroup, FormControlLabel, Radio,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";

import { fetchBusinessProcess, updateBusinessProcess } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function BusinessProcessEditPage() {
  const { businessDomainId, businessProcessId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [form, setForm] = useState({
    businessProcessId: "",
    companyId: "",
    businessDomainId: "",
    businessProcessName: "",
    businessProcessDescription: "",
    businessProcessType: "",
    businessProcessClass: "",
    url: "",
  });

  useEffect(() => {
    (async () => {
      try {
        const d = await fetchBusinessProcess(businessProcessId);
        setForm({
          businessProcessId: d.businessProcessId || "",
          companyId: d.companyId || "",
          businessDomainId: d.businessDomainId || "",
          businessProcessName: d.businessProcessName || "",
          businessProcessDescription: d.businessProcessDescription || "",
          businessProcessType: d.businessProcessType || "CoreProcess",
          businessProcessClass: d.businessProcessClass || "Operation",
          url: d.url || "",
        });
      } catch (e) {
        notify.apiError(e);
      }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessProcessId]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateBusinessProcess(form);
      notify.success(t("message.update.success"));
      navigate(`/design/${businessDomainId}/business-processes/${businessProcessId}`);
    } catch (err) {
      notify.apiError(err);
    }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {t("businessProcess.edit.title")}
      </Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField
              fullWidth
              required
              multiline
              label={t("businessProcess.name")}
              name="businessProcessName"
              value={form.businessProcessName}
              onChange={handleChange}
            />
          </Grid>

          <Grid size={12}>
            <TextField
              fullWidth
              multiline
              rows={3}
              label={t("businessProcess.description")}
              name="businessProcessDescription"
              value={form.businessProcessDescription}
              onChange={handleChange}
            />
          </Grid>

          <Grid size={12}>
            <FormControl component="fieldset">
              <RadioGroup
                row
                name="businessProcessType"
                value={form.businessProcessType}
                onChange={handleChange}
              >
                <FormControlLabel value="CoreProcess" control={<Radio />} label={t("businessProcess.type.coreProcess")} />
                <FormControlLabel value="BusinessSupportProcess" control={<Radio />} label={t("businessProcess.type.businessSupportProcess")} />
                <FormControlLabel value="EnterpriseSupportProcess" control={<Radio />} label={t("businessProcess.type.enterpriseSupportProcess")} />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid size={12}>
            <FormControl component="fieldset">
              <RadioGroup
                name="businessProcessClass"
                value={form.businessProcessClass}
                onChange={handleChange}
              >
                <FormControlLabel value="Operation" control={<Radio />} label={t("businessProcess.class.operation")} />
                <FormControlLabel value="CustomerRelationshipManagement" control={<Radio />} label={t("businessProcess.class.crm")} />
                <FormControlLabel value="ProductLifeCycleManagement" control={<Radio />} label={t("businessProcess.class.plm")} />
                <FormControlLabel value="HumanResourceManagement" control={<Radio />} label={t("businessProcess.class.hrm")} />
                <FormControlLabel value="InvestorRelationshipManagement" control={<Radio />} label={t("businessProcess.class.irm")} />
                <FormControlLabel value="PartnerRelationshipManagement" control={<Radio />} label={t("businessProcess.class.prm")} />
                <FormControlLabel value="DataManagement" control={<Radio />} label={t("businessProcess.class.dm")} />
                <FormControlLabel value="ItServiceManagement" control={<Radio />} label={t("businessProcess.class.itsm")} />
                <FormControlLabel value="AssetManagement" control={<Radio />} label={t("businessProcess.class.am")} />
                <FormControlLabel value="Financing" control={<Radio />} label={t("businessProcess.class.financing")} />
                <FormControlLabel value="GeneralManagement" control={<Radio />} label={t("businessProcess.class.generalManagement")} />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid size={12}>
            <TextField
              fullWidth
              multiline
              label={t("common.url")}
              name="url"
              value={form.url}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">
            {t("common.save")}
          </Button>
          <Button variant="outlined" onClick={() => navigate(`/design/${businessDomainId}/business-processes/${businessProcessId}`)}>
            {t("common.cancel")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
